<script>
export default {
  name: 'Card',
  props: ['name','localisation','_id', 'headerWidth'],
  computed: {
    cssProps() {
      if (this.headerWidth) {
        return {
          'width': this.headerWidth + "px",
        }
      } else {
        // Valeurs par defaut
        return {
          'width': "160px",
        }
      }
    }
  }
}
</script>


<template>
  <div class="card">
    <figure  v-on:click="$emit('clicked-link')">
      <slot name="figure">
        <img src="../../assets/projetIcon.png">
      </slot>
    </figure>
    <header  v-on:click="$emit('clicked-link')" :style="cssProps">
      <slot name="header">
        <div class="title"> {{name}} </div>
        <div class="subTitle"> {{localisation}} </div>
      </slot>
    </header>
    <body>
      <slot name="body">

      </slot>
    </body>
    <footer>
      <slot name="footer">
        <span class="material-icons" v-on:click="$emit('clicked-over')">swap_vert</span>
        <span class="material-icons" v-on:click="$emit('clicked-delete')">delete_outline</span>
      </slot>
    </footer>
  </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/main.scss';

.card{
  @include myBlock;
  display: flex;
  padding: 0;
  height: 50px;
  
  & figure{
    margin: 0 10px 0 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    overflow: hidden;
    width: 100px;

    & img{
      height: 100%;
    }
  }

  & header{
    // width: 160px;
    // Width gérée par le computed "cssProps"
    overflow: hidden;
    cursor: pointer;

    & .title{
      @include myFont;
      @include monoline;
      font-weight: 600;
      font-size: 14px;
      color: $main;
      margin: 7px 0 2px 0;
    }

    & .subTitle{
      @include myFont;
      @include monoline;
      font-size: 12px;
      color: $black-bolder;
    }
  }

  & body{
    flex: 1;
    padding: 0 0px 0 0px;
    margin: 0 0 0px 0;
  }

  & footer{
    display: flex;
    align-items: center;
  }

}

</style>
